import React, { useState } from 'react';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import Pricing from '../components/landing/Pricing';
import LeadForm from '../components/landing/LeadForm';
import Footer from '../components/landing/Footer';

export default function Landing() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formState, setFormState] = useState({
    interest: 'Demo',
    plan: 'None'
  });

  const handleGetStartedClick = () => {
    setFormState({ interest: 'Demo', plan: 'None' });
    setIsModalOpen(true);
  };

  const handleSubscribeClick = (planName) => {
    setFormState({ interest: 'Subscription', plan: planName });
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen">
      <Hero onGetStartedClick={handleGetStartedClick} />
      <Features />
      <Pricing onSubscribeClick={handleSubscribeClick} />
      <Footer />

      <LeadForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialInterest={formState.interest}
        initialPlan={formState.plan}
      />
    </div>
  );
}
